import { Icon, Tag, Tooltip } from '@chakra-ui/react'
import { Unplug } from 'lucide-react'

export function ClusterSyncDisabled() {
  return (
    <Tooltip.Root positioning={{ placement: 'top' }}>
      <Tooltip.Trigger asChild>
        <Tag.Root size="md" colorPalette="red" gap={2}>
          <Icon as={Unplug} />
          <Tag.Label>Sync disabled</Tag.Label>
        </Tag.Root>
      </Tooltip.Trigger>
      <Tooltip.Positioner>
        <Tooltip.Content>
          <Tooltip.Arrow />
          This cluster has automatic synchronization disabled. Changes to
          configurations will not be applied automatically.
        </Tooltip.Content>
      </Tooltip.Positioner>
    </Tooltip.Root>
  )
}
